import React, { Component, Fragment } from 'react';
import moment from 'moment';
import _ from 'lodash';
import { Grid, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';

import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import { TransactionSummaryEnum } from 'Common/FieldEnum';
import { TRANSACTION_SUMMARY_LIST_FORM_NAME } from 'Common/FormEnum';
import { Filter, Main } from 'Containers';
import { resetForm } from 'State/forms/actions';
import { errorToast } from 'Common/ToastHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import {
  PrintOptionsEnum,
  PrintSortTypeEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { resetDirty } from 'State/dirtyTracking/actions';

import { actions } from '../../state/actions';
import TransactionSummaryListComponent from '../../components/transactionSummaryList/TransactionSummaryListComponent';

import 'Styles/pages/inventory/transaction/transactionSummary/index.less';

class TransactionSummaryListContainer extends Component {
  state = {
    activeIndexes: [0, 1],
  };

  reactTableRef = React.createRef();
  reactTableWrapperInstance = null;

  async componentDidMount() {
    const {
      getExistingTranSummaryDtls,
      getTranBeginEndDate,
      beginDT,
      endDT,
      change,
      resetDirty,
    } = this.props;
    if (!beginDT && !endDT) {
      await getTranBeginEndDate(beginDT, endDT);
      await getExistingTranSummaryDtls({
        FromDt: moment(
          this.props.transactionBeginEndDate[TransactionSummaryEnum.BeginDT]
        ).format(DATE_FORMAT_FOR_SERVER),
        ToDt: moment(
          this.props.transactionBeginEndDate[TransactionSummaryEnum.EndDT]
        ).format(DATE_FORMAT_FOR_SERVER),
      });
      change(
        TransactionSummaryEnum.BeginDT,
        moment(
          this.props.transactionBeginEndDate[TransactionSummaryEnum.BeginDT]
        ).format(DATE_FORMAT_FOR_UI)
      );

      change(
        TransactionSummaryEnum.EndDT,
        moment(
          this.props.transactionBeginEndDate[TransactionSummaryEnum.EndDT]
        ).format(DATE_FORMAT_FOR_UI)
      );

      this.props.setToDateMin(
        moment(
          this.props.transactionBeginEndDate[TransactionSummaryEnum.BeginDT],
          DATE_FORMAT_FOR_UI
        )
      );
      this.props.setFromDateMax(
        moment(
          this.props.transactionBeginEndDate[TransactionSummaryEnum.EndDT],
          DATE_FORMAT_FOR_UI
        )
      );
    } else {
      await getExistingTranSummaryDtls({
        FromDt: moment(beginDT, DATE_FORMAT_FOR_UI).format(
          DATE_FORMAT_FOR_SERVER
        ),
        ToDt: moment(endDT, DATE_FORMAT_FOR_UI).format(DATE_FORMAT_FOR_SERVER),
      });
    }
    resetDirty();
  }
  componentDidUpdate(prevProps) {
    const { clearTransactionSummaryError } = this.props;
    if (
      errorToast(this.props, prevProps, 'fetchTransactionSummaryDateError') ||
      errorToast(
        this.props,
        prevProps,
        'fetchTransactionBeginEndDateLoadingError'
      ) ||
      errorToast(this.props, prevProps, 'cancelProcessError') ||
      errorToast(
        this.props,
        prevProps,
        'fetchExistingTranSummaryPrintLoadingError'
      )
    ) {
      clearTransactionSummaryError();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  onChangeOfFromDT = (e, beginDate, prevDate) => {
    beginDate !== prevDate && this.selectFromDate(e, beginDate);
  };

  onChangeOfToDT = (e, endDate, prevDate) => {
    endDate !== prevDate && this.selectToDate(e, endDate);
  };

  selectFromDate = (e, beginDate) => {
    this.props.setToDateMin(moment(beginDate, DATE_FORMAT_FOR_UI));
    const { endDT, getExistingTranSummaryDtls } = this.props;
    beginDate &&
      getExistingTranSummaryDtls({
        FromDt: moment(beginDate, DATE_FORMAT_FOR_UI).format(
          DATE_FORMAT_FOR_SERVER
        ),
        ToDt: moment(endDT, DATE_FORMAT_FOR_UI).format(DATE_FORMAT_FOR_SERVER),
      });
  };

  selectToDate = (e, endDate) => {
    this.props.setFromDateMax(moment(endDate, DATE_FORMAT_FOR_UI));
    const { beginDT, getExistingTranSummaryDtls } = this.props;
    endDate &&
      getExistingTranSummaryDtls({
        FromDt: moment(beginDT, DATE_FORMAT_FOR_UI).format(
          DATE_FORMAT_FOR_SERVER
        ),
        ToDt: moment(endDate, DATE_FORMAT_FOR_UI).format(
          DATE_FORMAT_FOR_SERVER
        ),
      });
  };

  printTransactionSummary = () => {
    const {
      printOptionsValue,
      transactionSummaryGrid,
      getExistingTranSummaryPrint,
      transactionSummaryDates,
    } = this.props;
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: this.props.data };
    const ids = [];
    _.forEach(dataObjs.sortedData, obj => {
      const id = obj[TransactionSummaryEnum.Id]
        ? obj[TransactionSummaryEnum.Id]
        : obj._original[TransactionSummaryEnum.Id];
      if (transactionSummaryGrid.indexOf(id) !== -1) {
        ids.push(id);
      }
    });
    transactionSummaryDates &&
      transactionSummaryDates.length &&
      getExistingTranSummaryPrint({
        SortType:
          printOptionsValue === PrintOptionsEnum.ItemCode
            ? PrintSortTypeEnum.ItemCode
            : PrintSortTypeEnum.ItemDescription,
        Ids:
          ids && ids.length
            ? ids
            : [transactionSummaryDates[0][TransactionSummaryEnum.Id]],
        ShowDetails: true,
      });
  };
  handleCollapsePanelClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    activeIndexes.indexOf(index) !== -1
      ? activeIndexes.splice(activeIndexes.indexOf(index), 1)
      : activeIndexes.push(index);
    this.setState({ activeIndexes });
  };
  onAddClick = () => {
    this.props.history.push('/transactionSummary/create');
  };
  clearFilters = () => {
    const {
      change,
      transactionBeginEndDate,
      resetForm,
      getExistingTranSummaryDtls,
    } = this.props;
    resetForm(TRANSACTION_SUMMARY_LIST_FORM_NAME);
    change(
      TransactionSummaryEnum.BeginDT,
      moment(transactionBeginEndDate[TransactionSummaryEnum.BeginDT]).format(
        DATE_FORMAT_FOR_UI
      )
    );
    change(
      TransactionSummaryEnum.EndDT,
      moment(transactionBeginEndDate[TransactionSummaryEnum.EndDT]).format(
        DATE_FORMAT_FOR_UI
      )
    );

    getExistingTranSummaryDtls({
      FromDt: moment(
        this.props.transactionBeginEndDate[TransactionSummaryEnum.BeginDT]
      ).format(DATE_FORMAT_FOR_SERVER),
      ToDt: moment(
        this.props.transactionBeginEndDate[TransactionSummaryEnum.EndDT]
      ).format(DATE_FORMAT_FOR_SERVER),
    });
    this.reactTableWrapperInstance &&
      this.reactTableWrapperInstance.clearTableState();
  };
  setReactTableWrapperInstance = ref => {
    this.reactTableWrapperInstance = ref;
  };
  render() {
    const {
      transactionSummaryDates,
      printOptionsValue,
      fetchTransactionSummaryDateLoading,
      fetchTransactionBeginEndDateLoading,
      fetchExistingTranSummaryPrintLoading,
    } = this.props;
    const { fromDateMax, toDateMin } = this.props;

    return (
      <Fragment>
        {fetchTransactionBeginEndDateLoading && <LoadingPage />}
        <Filter title={'Transaction Summary'}>
          <Grid>
            <Grid.Row column={2}>
              <Grid.Column width={12} />
              <Grid.Column width={4} floated={'right'} textAlign={'right'}>
                <Button
                  content="Create New"
                  type={'button'}
                  onClick={this.onAddClick}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main shouldNotUsePageWidth>
          <TransactionSummaryListComponent
            reactTableRef={this.reactTableRef}
            transactionData={[]}
            onChangeOfFromDT={this.onChangeOfFromDT}
            fromDateMax={fromDateMax}
            toDateMin={toDateMin}
            onChangeOfToDT={this.onChangeOfToDT}
            transactionSummaryDates={transactionSummaryDates}
            printOptionsValue={printOptionsValue}
            printTransactionSummary={this.printTransactionSummary}
            handleCollapsePanelClick={this.handleCollapsePanelClick}
            activeIndexes={this.state.activeIndexes}
            fetchTransactionSummaryDateLoading={
              fetchTransactionSummaryDateLoading
            }
            fetchExistingTranSummaryPrintLoading={
              fetchExistingTranSummaryPrintLoading
            }
            clearFilters={this.clearFilters}
            setReactTableWrapperInstance={this.setReactTableWrapperInstance}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(TRANSACTION_SUMMARY_LIST_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  const { transactionSummaryList } = state.TransactionSummaryState;
  const {
    transactionSummaryDates,
    fetchTransactionSummaryDateError,
    fetchTransactionSummaryDateLoading,
    transactionBeginEndDate,
    fetchTransactionBeginEndDateLoading,
    fetchTransactionBeginEndDateLoadingError,
    fetchExistingTranSummaryPrintLoading,
    fetchExistingTranSummaryPrintLoadingError,
    fromDateMax,
    toDateMin,
  } = transactionSummaryList;

  ownProps.setPageLevelDirty(
    getIsDirty(TRANSACTION_SUMMARY_LIST_FORM_NAME)(state)
  );

  return {
    transactionSummaryDates: transactionSummaryDates,
    transactionBeginEndDate: transactionBeginEndDate,
    beginDT: selector(state, TransactionSummaryEnum.BeginDT),
    endDT: selector(state, TransactionSummaryEnum.EndDT),
    printOptionsValue: selector(state, TransactionSummaryEnum.PrintOptions),
    transactionSummaryGrid: selector(
      state,
      TransactionSummaryEnum.TransactionSummaryGrid
    ),
    initialValues: {
      [TransactionSummaryEnum.BeginDT]: moment()
        .subtract(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [TransactionSummaryEnum.EndDT]: moment()
        .add(1, 'month')
        .format(DATE_FORMAT_FOR_UI),
      [TransactionSummaryEnum.PrintOptions]: TransactionSummaryEnum.ItemCode,
      [TransactionSummaryEnum.TransactionSummaryGrid]: [],
    },
    fetchTransactionSummaryDateLoading,
    fetchTransactionSummaryDateError,
    fetchTransactionBeginEndDateLoading,
    fetchTransactionBeginEndDateLoadingError,
    fetchExistingTranSummaryPrintLoading,
    fetchExistingTranSummaryPrintLoadingError,
    fromDateMax,
    toDateMin,
  };
};
TransactionSummaryListContainer = reduxForm({
  destroyOnUnmount: false,
  form: TRANSACTION_SUMMARY_LIST_FORM_NAME,
})(TransactionSummaryListContainer);

export const TransactionSummary = connect(
  mapStateToProps,
  {
    ...actions,
    resetForm,
    resetDirty,
  }
)(TransactionSummaryListContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/containers/transactionSummaryList/TransactionSummaryListContainer.js